import { Typography } from "@saviynt/design-system";
import { FormattedMessage } from "react-intl";

export default function MFA() {
  return (
    <div className="p-6">
      <Typography kind="h1" className="mb-6">
        <FormattedMessage
          id="KNQMLN"
          defaultMessage="MFA"
          description="MFA page title"
        />
      </Typography>
      <div
        className="p-8 rounded-lg shadow text-center"
        style={{
          backgroundColor: "var(--color-background-secondary-subtlest)",
        }}
      >
        <Typography kind="h2">
          <FormattedMessage
            id="3yZip7"
            defaultMessage="Coming Soon"
            description="Coming soon message"
          />
        </Typography>
      </div>
    </div>
  );
}
